var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        { attrs: { icon: "" }, on: { click: _vm.click } },
        [
          _c("v-icon", [
            _vm._v(_vm._s(_vm.isFullscreen ? "fullscreen_exit" : "fullscreen"))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }